import React, { useCallback, useEffect, useState } from 'react'
import { getChannelPkgList } from '../utils/network'
import useList from 'hooks/useList'
import { formatChannelPkgList } from '../utils/formatChannelPkgList'
import showUploadDialog from '../utils/showUploadDialog'
import Button from '@tencent/spaui-button'
import ChangeChannelName from 'biz-components/ChangeChannelName'
import {
    CHANNEL_PKG_STATUS_NAME,
    CHANNEL_PKG_STATUS,
    ALLOWED_REPLACE_STATUS,
    CHANNEL_PKG_STATUS_TIPS,
    PLATFORM_NAME,
} from '../constants'

const useChannelPkgList = (appInfo = {}) => {
    const genUpdateDataAPIParams = params => {
        const req = {}
        req[params.searchName] = params.filterText
        req.appid = appInfo.appId
        return req
    }
    const genUpdateDataAPIParamsMemo = useCallback(genUpdateDataAPIParams, [appInfo.appId])
    const [bodyHeight, setBodyHeight] = useState(document.body.clientHeight - 300)
    useEffect(() => {
        window.addEventListener('resize', () => {
            setBodyHeight(document.body.clientHeight - 300)
        })
    }, [])

    const { state, setState } = useList({
        updateDataAPI: getChannelPkgList,
        genUpdateDataAPIParams: genUpdateDataAPIParamsMemo,
        derivedData: null,
        dataFormatter: formatChannelPkgList,
        filterSelectValue: -1,
    })

    const showSingleReplaceDialog = (channelPkgInfo, e) => {
        e.preventDefault()
        showUploadDialog({
            dialogType: 'singleReplace',
            appInfo,
            channelPkgInfo,
        })
    }

    const showMultiUploadDialog = () => {
        showUploadDialog({ dialogType: 'multiUpload', appInfo })
    }

    const showMultiReplaceDialog = () => {
        showUploadDialog({ dialogType: 'multiReplace', appInfo })
    }

    const onRowChannelNameEditClick = (rowDatas, rowIndex) => {
        rowDatas.forEach(row => {
            row.isShowDialog = false
        })
        rowDatas[rowIndex].isShowDialog = true
    }

    const onRowChannelNameEditCancel = (rowDatas, rowIndex) => {
        rowDatas[rowIndex].isShowDialog = false
    }

    const initRowOnClickHandler = data => {
        data.forEach((row, index) => {
            row.onEditClick = () => {
                const newListData = JSON.parse(JSON.stringify(data))
                initRowOnClickHandler(newListData)
                onRowChannelNameEditClick(newListData, index)
                setState.setData(newListData)
            }
            row.onHideDialog = () => {
                const newListData = JSON.parse(JSON.stringify(data))
                initRowOnClickHandler(newListData)
                onRowChannelNameEditCancel(newListData, index)
                setState.setData(newListData)
            }
        })
    }

    if (state && state.data) {
        initRowOnClickHandler(state.data)
    }

    const colRender = (type, rowName, value, rowData) => {
        if (type !== 'head') {
            if (rowName === 'operate') {
                if (ALLOWED_REPLACE_STATUS.includes(rowData.originStatus)) {
                    return (
                        <div className="a-table-action channel-package-table-action">
                            <a href="void:0" onClick={e => showSingleReplaceDialog(rowData, e)}>
                                更新
                            </a>
                        </div>
                    )
                }
            } else if (rowName === 'status') {
                if (value === CHANNEL_PKG_STATUS_NAME[CHANNEL_PKG_STATUS.AUDIT_FAIL]) {
                    return <div className="channel-package-error-text">{value}</div>
                } else if (rowData.needToUpdate) {
                    return (
                        <div>
                            <span>{value}</span>
                            <br />
                            <span className="channel-package-error-text">{CHANNEL_PKG_STATUS_TIPS.NEED_TO_UPDATE}</span>
                        </div>
                    )
                }
            } else if (rowName === 'channelName') {
                return (
                    <ChangeChannelName
                        appId={rowData.appId}
                        channelName={rowData.channelName}
                        channelKey={rowData.channelKey}
                        isShowDialog={rowData.isShowDialog}
                        onEditClick={rowData.onEditClick}
                        onHideDialog={rowData.onHideDialog}
                    />
                )
            } else if (rowName === 'platform') {
                return PLATFORM_NAME[value]
            }
        }

        return value
    }

    const HeaderRightAddOn = () => {
        return (
            <div className="toolbar-right-group">
                <Button className="borderless" onClick={showMultiUploadDialog}>
                    <i className="icon icon-group-upload"></i>批量上传
                </Button>
                <Button className="borderless" onClick={showMultiReplaceDialog}>
                    <i className="icon icon-group-repeat"></i>批量替换
                </Button>
            </div>
        )
    }

    return {
        state,
        setState,
        colRender,
        HeaderRightAddOn,
        showMultiUploadDialog,
        showMultiReplaceDialog,
        genUpdateDataAPIParams,
        showSingleReplaceDialog,
        bodyHeight,
    }
}

export default useChannelPkgList
